import styled from 'styled-components';
import theme from 'style/theme';
import { Link } from 'react-router-dom';


function BackButton(props) {
  return (
    <Link to={`/${props.id}`}>
      <Back>{props.value}</Back>
    </Link>
  );
}


const Back = styled.button`
  width: 21.25rem;
  height: 3.5rem;
  border-radius: 1.875rem;
  background-color: white;
  border: solid 0.125rem ${theme.blue};
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: ${theme.textBase};
  line-height: 1.188rem;
  color: ${theme.blue};
`;

export default BackButton;
